<div class="page-content">
    <div class="body-data">
        <div class="main">
            <div class="mt-10 mb-10">
                <div class="stepper-wrapper">
                    <div class="stepper-item completed">
                      <div class="step-counter">
                        <i class="fas fa-check"></i>
                        <i class="fas fa-square"></i>
                    </div>
                      <div class="step-name">Choose a date:</div>
                    </div>
                    <div class="stepper-item active">
                      <div class="step-counter">
                        <i class="fas fa-check"></i>
                        <i class="fas fa-square"></i>
                    </div>
                      <div class="step-name">Select a date and time:</div>
                    </div>
                    <div class="stepper-item ">
                      <div class="step-counter">
                        <i class="fas fa-check"></i>
                        <i class="fas fa-square"></i>
                    </div>
                      <div class="step-name">Contact Info:</div>
                    </div>
                  
                  </div>
                  <div class="cls-calendar">
                    <div class="clstimeblock col-md-4">
                        <div class="mb-10">
                            <!-- <div class="active light col-md-6 clearfix">
                                <input type="radio" name="" value="">
                                <div class="pull-right ">
                                <p class="semi">15 Mins</p>
                                <p>Say Hello!</p>
                                </div>
                            </div> -->
                           
                            <div class="col-md-8 clearfix">
                                <mat-radio-group
                                aria-labelledby="example-radio-group-label"
                                class="example-radio-group"
                                [(ngModel)]="favoriteSeason" (change)="radioChange()">
                                <mat-radio-button class="example-radio-button light active" *ngFor="let season of seasons" [value]="season">
                                  {{season}}
                                  <p>Say Hello</p>
                                </mat-radio-button>
                              </mat-radio-group>
                            </div>
                        </div>
                    </div> 
                    <div class="col-md-4">
                    <div class="clswidcal">
                     <mat-calendar [(selected)]="selectedDate" (selectedChange)="onSelectDate($event)"></mat-calendar>
                     <div class="timing">
                        <h3>{{selectedDate | date:'longDate'}} </h3>
                        <ul>
                            <li *ngFor="let item of timeArray" (click)="timeTrigger(item)" [ngClass]="timeValue == item ? 'active' : ''" >
                                <a>{{item}}</a>
                            </li>
                        </ul>
                        <div class="clsicon">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        <span class="cls-ist">
                            All times are in central time <a>Indian (IST +8)</a></span>
                        </div>
                        <div>
                            <button class="orange">Cancel</button>
                            <button class="bor-orange" (click)="createAppointment()">Confirm</button>
                        </div>
                     </div>
                    </div>
                     </div>
                    <div class="cls-forms col-md-4">
                        <form [formGroup]="contactInfoForm">
                            <div class="form-group row">
                                <label  class="col-sm-4 col-form-label">Full Name</label>
                                <div class="col-sm-8 pl-0">
                                  <input type="name" formControlName="fullName" class="form-control" placeholder="">
                                </div>
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.controls.fullName.invalid">Name Required</span> 
                              </div>
                              <div class="form-group row">
                                <label  class="col-sm-4 col-form-label">Phone</label>
                                <!-- <div class="col-sm-2 pl-0">
                                    <input type="tel" class="form-control tel" name="phone">
                                  </div> -->
                                <div class="col-sm-8 pl-0">
                                  <input type="tel" formControlName="phoneNumber" class="form-control" name="phone" placeholder="">
                                </div>
                                <!-- <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.controls.phoneNumber.invalid">Phone Number Required</span>  -->
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.get('phoneNumber').errors?.required">Phone Number Required</span> 
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && !contactInfoForm.get('phoneNumber').errors?.required && contactInfoForm.controls.phoneNumber.invalid">Invalid Phone Number</span> 
                              </div>
                              <div class="form-group row">
                                <label  class="col-sm-4 col-form-label">Email</label>
                                <div class="col-sm-8 pl-0">
                                  <input type="email" formControlName="email" class="form-control" >
                                </div>
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.get('email').errors?.required">Email Required</span> 
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.get('email').errors?.email">Invalid Email</span> 
                              </div>
                              <div class="form-group row">
                                <a class="addguest col-sm-8">Add Guest <i class="fa fa-chevron-right" aria-hidden="true"></i>
                                </a>
                              </div>
                            
                              <div class="form-group row">
                                <label  class="col-sm-4 col-form-label">Industry</label>
                                <div class="col-sm-8 pl-0">
                                    <select id="" formControlName="industry" class="form-control arrow-img ">
                                        <option value="" selected>Select</option>
                                        <option value="Customer Order">Customer Order</option>
                                        <option value="Technical Support">Technical Support</option>
                                      </select>
                                </div>
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.controls.industry.invalid">Industry Required</span> 
                              </div>
                              <div class="form-group row">
                                <label  class="col-sm-4 col-form-label">Notes</label>
                                <div class="col-sm-8 pl-0">
                                 <textarea rows="4" cols="34" formControlName="notes">

                                 </textarea>
                                </div>
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.controls.notes.invalid">Notes Required</span> 
                              </div>

                              <div class="form-group row">
                                <div class="col-sm-4"></div>
                                <div class="input-group mb-2 col-sm-8 pl-0">
                                <input type="text" formControlName="fileName" class="form-control" id="" placeholder="Add PDF/ PPT">
                                  <div class="input-group-prepend upload-btn-wrapper">
                                        <input type="file" formControlName="addFile" (change)="onFileSelected($event)" accept=".ppt, .pptx, .pdf"/>
                                        <div class="input-group-text">Add</div>
                                  </div>                                   
                                </div>
                                <span class="form-error-text1" style="float: left;" *ngIf="isSubmitted && contactInfoForm.controls.addFile.invalid">File Required</span>
                              </div>
                              <div class="form-check clsradio">
                                <mat-checkbox  formControlName="notification" class="example-margin">Send me notification by email</mat-checkbox>
                                
                              </div>

                        </form>
                    </div>
                  </div>




                  
            </div>
        

        
        </div>
    </div>
</div>


<div *ngIf="showLoader" class="loader">
  <img src="assets/svg/preloader.svg" alt="">
</div>
